import React, { Component } from "react";

class Concert extends Component {
  render() {
    return (
      <div>
        <h3 className='centered'>{this.props.concert.overview}</h3>
        {this.props.concert.description && (
          <h5 className='centered'>
            {this.props.concert.description}
            <br />
          </h5>
        )}
        <div className='container centered flex-column align-items-center mt-2'>
          <img src={this.props.concert.poster} alt='Poster' width='36%' />
          {this.props.concert.eventUrl && (
            <p className='mt-2'>
              <a
                href={this.props.concert.eventUrl}
                target='_blank'
                rel='noopener noreferrer'
              >
                Περισσότερες πληροφορίες
              </a>
            </p>
          )}
        </div>
      </div>
    );
  }
}

export default Concert;
